import { render, staticRenderFns } from "./MenuModuleShortcut.vue?vue&type=template&id=45561268&scoped=true&"
import script from "./MenuModuleShortcut.vue?vue&type=script&lang=js&"
export * from "./MenuModuleShortcut.vue?vue&type=script&lang=js&"
import style0 from "./MenuModuleShortcut.vue?vue&type=style&index=0&id=45561268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45561268",
  null
  
)

export default component.exports